import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '@core/services/auth.service';
import { UserService } from '@core/services/user.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ToastService } from '@core/services/toast.service';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const userService = inject(UserService);
  const jwtHelper = inject(JwtHelperService);
  const toastService = inject(ToastService);
  const router = inject(Router);

  if (authService.getToken() && userService.getUser()) {
    if (!jwtHelper.isTokenExpired(authService.getToken())) {
      return true;
    } else {
      toastService.error('La sesión ha expirado');
    }
  }

  authService.clearSession();

  router.navigate(['/auth/login']);
  return false;
};
